import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AuthProvider from "./context/AuthProvider";
import { Toaster } from "react-hot-toast";
import SearchKeyProvider from "./context/SearchKeyProvider";
import { CartProvider } from "./context/CartProvider";
import WishListProvider from "./context/WishListProvider";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <SearchKeyProvider>
      <CartProvider>
        <WishListProvider>
          <AuthProvider>
            <Toaster />
            <App />
          </AuthProvider>
        </WishListProvider>
      </CartProvider>
    </SearchKeyProvider>
  </QueryClientProvider>
);
